module.exports = [
  'ASEAN countries',
  'Afghanistan',
  'Africa',
  'Alabama',
  'Alaska',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Anguilla',
  'Antigua and Barbuda',
  'Arctic Ocean',
  'Argentina',
  'Arizona',
  'Arkansas',
  'Armenia',
  'Asia',
  'Atlantic Coast (U.S.)',
  'Atlantic Ocean',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belgium',
  'Belize',
  'Bering Sea',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'British Virgin Islands',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burma',
  'Burundi',
  'California',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Caribbean Sea',
  'Caribbean area',
  'Cayman Islands',
  'Central African Republic',
  'Central America',
  'Central Europe',
  'Chad',
  'Chesapeake Bay',
  'Chile',
  'China',
  'Colombia',
  'Colorado',
  'Comoros',
  'Congo',
  'Connecticut',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Delaware',
  'Democratic Republic of the Congo',
  'Denmark',
  'Diego Garcia',
  'District of Columbia',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Europe',
  'Everglades',
  'Fiji',
  'Finland',
  'Florida',
  'France',
  'Gabon',
  'Gambia',
  'Gaza Strip',
  'Georgia',
  'Georgia (Republic)',
  'Germany',
  'Ghana',
  'Great Lakes',
  'Great Plains',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Gulf States',
  'Gulf of Mexico',
  'Guyana',
  'Haiti',
  'Hawaii',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'Idaho',
  'Illinois',
  'India',
  'Indiana',
  'Indonesia',
  'Iowa',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kansas',
  'Kazakhstan',
  'Kentucky',
  'Kenya',
  'Kiribati',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latin America',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Long Island Sound',
  'Louisiana',
  'Luxembourg',
  'Macau',
  'Macedonia',
  'Madagascar',
  'Maine',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Maryland',
  'Massachusetts',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Michigan',
  'Micronesia',
  'Middle East',
  'Minnesota',
  'Mississippi',
  'Mississippi River',
  'Missouri',
  'Missouri River',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montana',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Namibia',
  'Nauru',
  'Nebraska',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York City',
  'New York State',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North America',
  'North Carolina',
  'North Dakota',
  'North Korea',
  'North Macedonia',
  'Northern Ireland',
  'Northern Mariana Islands',
  'Norway',
  'Oceania',
  'Ohio',
  'Oklahoma',
  'Oman',
  'Oregon',
  'Pacific Ocean',
  'Pakistan',
  'Palau',
  'Panama',
  'Panama Canal',
  'Papua New Guinea',
  'Paraguay',
  'Pennsylvania',
  'Persian Gulf',
  'Persian Gulf States',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Puget Sound',
  'Qatar',
  'Rhode Island',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lawrence Seaway',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Serbia',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Asia',
  'South Carolina',
  'South Dakota',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Tennessee',
  'Texas',
  'Thailand',
  'Tibet',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos',
  'Tuvalu',
  'U.S.S.R.',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'Uruguay',
  'Utah',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vermont',
  'Vietnam',
  'Virgin Islands',
  'Virginia',
  'Washington State',
  'West Bank',
  'West Virginia',
  'Western Hemisphere',
  'Western Sahara',
  'Wisconsin',
  'Wyoming',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];
